<template>
  <v-container>
    <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">

      <v-row>
        <v-col md="12">
          <h1 class="font-weight-medium">{{ title }}</h1>
        </v-col>
      </v-row>

      <v-row>

        <v-col>
          <ValidationProvider v-slot="{ errors }" ref="xxx" rules="required">
            <v-text-field
                :label="$t('Nombre ')"
                filled
                v-model="item.nombre"
                maxlength="250"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
      </v-row>
            <v-row>

       <v-col>
        <v-select
                    v-model="item.tipo"
                    :items="$store.state.fileItems"
                    :item-text="'title'"
                    :item-value="'id'"
                    label="Typo"

          ></v-select>
       </v-col>
            </v-row>


      <v-row>
        <v-col>
          <!--<ValidationProvider v-slot="{ errors, validate, valid }" ref="xxx" rules="required|size:5000|ext:jpg,png">
            <v-file-input
                accept=".png,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                :label="$t('Archivo')"
                @change="handleFileChange"
            >
              <template v-slot:selection="{ text }">
                <v-chip
                    label
                    color="primary"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </ValidationProvider>-->

          <upload
              :files="[item.file]"
              :multiple="false"
              :title="$t('Adjuntos')"
              :hint="$t('Subir documento (s)')"
              :accept="'.doc,.docx,.zip,.pdf'"
              :validation="{required:false,size:15000,ext:['docx','pdf','zip','xlsx','png','jpg','jpeg']}"
              v-on:file-update="item.file = $event"
          ></upload>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn  @click="submit()" large color="primary" class="white--text">
            {{ $t('Guardar') }}
          </v-btn>

          <v-btn  @click="dialog=true" large color="red" class="white--text">
            {{ $t('Suprimir') }}
          </v-btn>
        </v-col>

      </v-row>
    </ValidationObserver>

    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-btn
            large color="primary" class="white--text"
            @click="dialog = false"
          >
            {{$t('No')}}
          </v-btn>

      <v-btn
           large color="red" class="white--text"
            @click="del"
          >
            {{$t('Suprimir')}}
          </v-btn>
    </v-dialog>

  </v-container>
</template>


<script>

    import axios from "axios"
    import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';
    import UploadService from "../../services/SimpleUploadService";
    import Upload from "@/components/Upload";


    setInteractionMode('eager')

    export default {
        data() {
            return {
                title: this.$i18n.t('Añadir Memoria'),
                mode: "post",
                id: "",
                text: "hjgjhg",
                item: {},
                progress: 0,
                dialog: false,
                typeData:null,

            };
        },
        components: {
            ValidationProvider, ValidationObserver, Upload
        },
        provide() {
            return {parentValidator: this.$validator}
        },
        methods: {
            submit() {
                this.$refs.observer.validate().then(success => {
                    if (!success) {
                        const el = document.querySelector(".v-messages.error--text:first-of-type");
                        el.scrollIntoView(true);
                        window.scrollBy(0, -150);
                        return;
                    }
                    console.log(this.item)
                    const config = {
                        method: this.mode,
                        url: this.$store.state.endpoints.memoria + this.id,
                        headers: {Authorization: "Bearer " + this.$store.state.jwt},
                        data: this.item
                    };
                    axios(config)
                        .then((response) => {
                            this.$router.push('/archivos/1');
                        })
                        .catch(error => {
                            console.log(error)
                        });
                })
            },
            del(){
                const config = {
                        method: "delete",
                        url: this.$store.state.endpoints.memoria + this.id,
                        headers: {Authorization: "Bearer " + this.$store.state.jwt},
                    };
                    axios(config)
                        .then((response) => {
                            this.$router.push('/archivos/1');
                        })
                        .catch(error => {
                            console.log(error)
                        });
            }
        },
        mounted() {
            if (this.$route.params.id) {

                this.id = this.$route.params.id+"/"
                this.mode = "put"
                this.title = this.$i18n.t("Editar Memoria");
                const config = {
                    headers: {Authorization: "Bearer " + this.$store.state.jwt},
                };
                axios.get(this.$store.state.endpoints.memoria + this.id , config)
                    .then((response) => {
                        this.item = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    });
            }
        }
    }
</script>





